function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.286,
    height: 18.475,
    viewBox: "0 0 24.286 18.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8076"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(5.491 15.119)",
    style: {
      fill: "none",
      stroke: "#ffa539",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h17.427"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path-5",
    d: "M0 10.463V-3.654",
    transform: "translate(23.286 4.654)",
    style: {
      fill: "none",
      stroke: "#ffa539",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 14",
    d: "M3.716 1.081a.5.5 0 0 1 .92 0l3.42 8.036a.5.5 0 0 1-.46.7H.756a.5.5 0 0 1-.46-.7z",
    transform: "rotate(-90 9.238 9.237)",
    style: {
      fill: "#ffa539"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIcon);
export default __webpack_public_path__ + "static/media/EnterIcon.eb7288f4df573600b98940333e54393d.svg";
export { ForwardRef as ReactComponent };